let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6kSK6")).then(() => parcelRequire('3ujSQ'));